/* eslint-disable @typescript-eslint/no-restricted-imports */
import { GUIEditor } from "../index";
const GlobalObject = typeof global !== "undefined" ? global : typeof window !== "undefined" ? window : undefined;
if (typeof GlobalObject !== "undefined") {
    GlobalObject.BABYLON = GlobalObject.BABYLON || {};
    GlobalObject.BABYLON.GuiEditor = GUIEditor;
    GlobalObject.BABYLON.GUIEditor = GUIEditor;
    // eslint-disable-next-line @typescript-eslint/naming-convention
    GlobalObject.GUIEDITOR = { GUIEditor };
}
export * from "../index";
//# sourceMappingURL=legacy.js.map